import dayjs from './dayjs'


export type { Dayjs } from './dayjs'
export default dayjs

export * from './formatDateRange'
export * from './difference'
